
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Text } from "@chakra-ui/react";


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Text textStyle="paragraph-sm" mdxType="Text">
  Nachfolgend sind alle Kategorien der gesetzlichen Erben aufgeführt. Wählen Sie
  jene Personen aus, die Sie im Fall Ihres Todes hinterlassen.
    </Text>
    <Text textStyle="paragraph-sm" mdxType="Text">
  Ich hinterlasse folgende gesetzlichen Erben:
    </Text>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;